export enum Tabs {
  MUNICIPALITIES = "municipalities",
  USERS = "users"
}
